import * as runtime from '@/api/runtime'

import {
  BatchStatisticsYearlyOutputRequest,
  BatchStatisticsYearlyOutputRequestToJSON
} from '@/api/models/batch/BatchStatisticsYearlyOutputConditionListItem'

export class BatchStatisticsYearlyOutputApi extends runtime.BaseAPI {
  /**
   * 統計実行
   * @param request
   */
  async createStatisticsYearlyOutput(
    request: BatchStatisticsYearlyOutputRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/yearly-output`,
      BatchStatisticsYearlyOutputRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
